// src/components/Hero.jsx
import React from "react";
import "../App.css";
import ImageSlider from "./SliderImg";

const Hero = ({ scrollToSection, imageSrc = "/hero.png", navigate, location }) => {
  return (
    <section
      id="home"
      className=" position-relative overflow-hidden hero"
      style={{
        background:
          "linear-gradient(120deg, rgba(1, 62, 251, 0.08) 0%, rgba(204, 214, 255, 0.06) 100%)",
      }}
    >
      <div className="container">
        <div className="row align-items-center ">
          {/* Text — now FIRST on mobile */}
          <div className="col-12 col-lg-6 order-1 order-lg-1">


            <h1 className="display-5 fw-bold mb-3" style={{ color: "var(--secondarytext)" }}>
              Engineering the Next Vision in Technology
            </h1>

            <p className="lead mb-4" style={{ color: "rgba(26, 34, 51, 0.8)" }}>
              From embedded systems to smart energy, we design & manufacture
              future-ready hardware for global industries.
            </p>

            <div className="d-flex flex-column flex-sm-row gap-3 hero-cta">
              <button
                type="button"
                className="btn btn-lg"
                onClick={() => {
                  if (location?.pathname === "/") {
                    // Try scrollToSection, fallback to direct scroll
                    if (scrollToSection) {
                      scrollToSection("products");
                    } else {
                      const el = document.getElementById("products");
                      if (el) {
                        const yOffset = -72;
                        const y = el.getBoundingClientRect().top + window.pageYOffset + yOffset;
                        window.scrollTo({ top: y, behavior: "smooth" });
                      }
                    }
                  } else if (navigate) {
                    navigate("/", { state: { scrollTo: "products" } });
                  }
                }}
                style={{ background: "var(--primary)", color: "white" }}
              >
                Our Products
              </button>

              <button
                type="button"
                className="btn btn-lg"
                style={{
                  background: "var(--chip)",
                  color: "var(--chiptext)",
                  border: "1px solid var(--primary-light)",
                }}
                onClick={() => (window.location.href = "/rfq")}
              >
                Request for quotation
              </button>

            </div>
          </div>

          {/* Image — now SECOND on mobile */}
          <div className="col-12 col-lg-6 order-2 order-lg-2">
            <div className="position-relative">
              <div aria-hidden="true" className="rounded-circle position-absolute translate-middle" />
             <ImageSlider/>
            </div>
          </div>
        </div>
      </div>

      {/* Scoped polish */}
      <style>{`
        .hero-cta .btn { 
          border: none; 
          border-radius: 12px; 
          padding-inline: 1.25rem; 
          font-weight: 600;
          transition: all 0.3s ease;
        }
        .hero-cta .btn:first-child:hover { 
          background: var(--primary-dark);
          transform: translateY(-2px);
          box-shadow: 0 4px 12px rgba(1, 62, 251, 0.3);
        }
        .hero-cta .btn:last-child:hover { 
          background: var(--chipalt);
          transform: translateY(-2px);
          box-shadow: 0 4px 12px rgba(204, 214, 255, 0.4);
        }
        @media (prefers-reduced-motion: reduce) {
          .hero-cta .btn { transition: none; }
        }
      `}</style>
    </section>
  );
};

export default Hero;
